module.exports = __webpack_public_path__ + "static/assets/a8547a49cb272a0281b7eab3144043ca.png";